import React, { Fragment } from 'react';

/**
 * Safely renders tags into a string, which has e.g. been obtained from
 * translation. The motivation is to avoid using `dangerouslySetInnerHtml`,
 * which is potentially unsafe. Escaping is also not trivial because it
 * depends on where in the html the to be escaped value is used.
 *
 * @param text the string to render, e.g. `"Hallo #world#Welt#worldend#!"`
 * @param render rendering function which in the example is passed `"world"`, `"Welt"` and `"worldend"` in this order
 *
 * @return text with the content returned by `render` rendered into it
 */
export const renderTagsIntoText = (
  text: string,
  render: (key: string, content: string, keyEnd: string) => JSX.Element
) => {
  const split = text.split('#');
  if ((split.length - 1) % 4 !== 0) {
    return <>[Error]</>;
  }

  return (
    <>
      {Array.from(Array((split.length + 3) / 4)).map((_, idx) => {
        idx = idx * 4;
        return (
          <Fragment key={idx}>
            {split[idx]}
            {idx + 1 < split.length && render(split[idx + 1], split[idx + 2], split[idx + 3])}
          </Fragment>
        );
      })}
    </>
  );
};
